<template>
  <div class="main-body">
    <div class="header">
      APP商品
    </div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-input placeholder="输入商品名称" v-model="name" clearable style="margin-right:10px;width:150px"></el-input>

          <el-cascader style="margin-right: 10px" placeholder="选择分类" size="mini"
              v-model="goodsClassGovernmentCode"
              :options="goodsClassGovernmentCodeArr"
              :props = "options"
              clearable></el-cascader>

          <el-select v-model="status" placeholder="选择状态" clearable style="width:120px;margin-right:10px">
            <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>


          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border ref="goodsTable">
        <el-table-column prop="name" fixed='left' label="标题" min-width="200"></el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handlePrice(scope.row)">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="stock" label="库存"></el-table-column>

        <el-table-column prop="goodsClassGovernmentName" label="分类"></el-table-column>

        <el-table-column :formatter="goodsTypeValue" label="类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.goodsType == 1">普通商品</span>
            <span v-if="scope.row.goodsType == 2">服务不可合并</span>
            <span v-if="scope.row.goodsType == 3">服务可合并</span>
          </template>
        </el-table-column>

        <el-table-column label="轮播图" width="100">
          <template slot-scope="scope">
            <el-button type="success" plain size="mini" @click="handlecarousel(scope.row)">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column label="推荐">
          <template slot-scope="scope">
            <span v-show="scope.row.isRecommend==1">是</span>
          </template>
        </el-table-column>

        <el-table-column label="特价">
          <template slot-scope="scope">
            <span v-show="scope.row.isBargainPrice==1">是</span>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==1" size="mini">正常</el-tag>
            <el-tag v-if="scope.row.status==2" type="danger" size="mini">下架</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>

        <el-table-column label="操作" fixed='right' width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small background layout="prev, pager, next" :total="totalItems"
                         :page-size="20" :current-page.sync="currentPage" @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <el-dialog
        title="轮播图"
        :visible.sync="showModalCarousel"
        center
        top='30vh'
        width="600px" :close-on-click-modal='false'>
      <template>
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="item in carouselValue" :key="item">
            <el-image :src="imgUrl+item" fit='contain' style="width:100%;height:100%">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </template>
    </el-dialog>
    <el-dialog
        title="商品价格/库存"
        :visible.sync="showModalPrice"
        center
        top='30vh'
        width="600px" :close-on-click-modal='false'>
      <template>
        <el-table
            :data="goodsPriceDTOList"
            :span-method="arraySpanMethods"
            border
            height="350"
            v-if="goodsPriceDTOList.length>0"
            style="width: 100%">
          <el-table-column
              v-if="goodsPriceDTOList[0].goodsColorName"
              prop="goodsColorName"
              label="颜色">
          </el-table-column>
          <el-table-column
              v-if="goodsPriceDTOList[0].goodsSizeName"
              prop="goodsSizeName"
              label="尺寸">
          </el-table-column>
          <el-table-column
              prop="price"
              label="单价（元）">
          </el-table-column>
          <el-table-column
              prop="stock"
              label="库存">
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>


    <Add ref="myAdd" v-show="showModalAdd" v-bind:goodsClassGovValue="goodsClassGovernmentCodeArr" v-bind:goodsClassBusinessValue="goodsClassBusinessValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-bind:goodsClassGovValue="goodsClassGovernmentCodeArr" v-bind:goodsClassBusinessValue="goodsClassBusinessValue"  v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      tableLoading: false,
      loading:false,

      showModalAdd:false,
      showModalCarousel:false,

      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },

      showModalPrice:false,
      showModalEdit:false,
      showModalAddClass:false,

      tableData:null,
      goodsClassCode:'',
      column:'',
      carouselValue:[],
      goodsPriceDTOList:[],
      imgUrl:this.$imgUrl,


      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      status:'',
      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '下架'
      }],

      goodsClassGovernmentCode:'',
      goodsClassGovernmentCodeArr:[],
      name:'',

      goodsClassBusinessValue:[],

    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    init:function(){
      this.getClassGov();
      this.getClassBus();
      this.getList();
    },

    getClassGov:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsClassGovernment/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.goodsClassGovernmentCodeArr = response.data.data;
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },
    getClassBus:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsClassBusiness/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.goodsClassBusinessValue = response.data.data;
            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


    handlecarousel(row){
      this.carouselValue=[]
      for(var i=0;i<4;i++){
        if(row['head'+(i+1)]){
          this.carouselValue.push(row['head'+(i+1)])
        }
      }
      this.showModalCarousel=true
    },

    handlePrice(row){
      this.goodsPriceDTOList=row.goodsPriceDTOList
      this.goodsPriceDTOList.sort(this.compare('goodsColorName'))
      this.showModalPrice=true
    },

    arraySpanMethods({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if(rowIndex ===0 || row.goodsColorName != this.goodsPriceDTOList[rowIndex-1].goodsColorName){
          let rowspan = 0;
          this.goodsPriceDTOList.forEach(element => {
            if(element.goodsColorName === row.goodsColorName){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
      this.column=column
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1.localeCompare(value2);
      }
    },
    goodsTypeValue(row){
      if(row.goodsType==1){
        return '普通类'
      }else if(row.goodsType==2){
        return '服务不可合并类'
      }else{
        return '服务可合并类'
      }
    },

    timefilter(row){
      return timefilters(row.createTime)
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },

    toggleModalAdd:function(){
      this.showModalAddClass = false;
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        status:this.status==''?-1:this.status,
        name:this.name,
        goodsClassGovernmentCode:this.goodsClassGovernmentCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/PageForBusinessNormal",
        data: data
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;

          this.$nextTick(()=>{
            this.$refs.goodsTable.doLayout()
          })

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


    handleDelete:function (index,row){

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.deleteDo(row.goodsCode);

      }).catch(e=>e)

    },

    deleteDo(goodsCode){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        goodsCode:goodsCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/Delete",
        data: data
      }).then( (response)=> {
        if(response.data.error == 0){
          this.$message.info("删除成功");
          this.getList();
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
